import { NgModule } from '@angular/core';
import { COMMON_MODULES } from '../../constants/common-modules';
import { AllowanceFormModule } from '../allowance-form/allowance-form.module';
import { AllowanceVariableComponent } from './allowance-variable.component';

@NgModule({
  declarations: [AllowanceVariableComponent],
  imports: [...COMMON_MODULES, AllowanceFormModule],
  exports: [AllowanceVariableComponent],
})
export class AllowanceVariableModule {}
